<twc-popup caption="{{'TAB_LAYERS.EXPORT_PROJECT'| translate}}" type="primary" width="m" [closable]="false">

    <twc-popup-content *ngIf="isPrincipalPopup">
        <p>{{'TAB_LAYERS.EXPORT_PROJECT_MESSAGE' | translate}}</p>

        <div class="twc-message-box twc-message-box-warning" *ngIf="isExported && !isSite">
            {{ 'TAB_LAYERS.MANUAL_DOWNLOAD' | translate}}
            <div class="direct-download">
                <button class="twc-button direct-download-button twc-mt-3 twc-mb-2" (click)="manualDownload()" [disabled]="!isDownloaded">
                    {{'EXPORT_LAYER_DIALOG.DIRECT_DOWNLOAD' | translate}}
                </button>
            </div>
        </div>
    </twc-popup-content>

    <twc-popup-footer *ngIf="isPrincipalPopup">

        <button class="twc-button twc-button-link" (click)="changePopups()"
            [disabled]="isExported && !isDownloaded && !jobOnProcess">
            {{'GENERAL.CANCEL' | translate}}
        </button>

        <button class="twc-button twc-button-primary twc-ml-3" *ngIf="!isExported" (click)="downloadProject()">
            {{'DOWNLOAD.DOWNLOAD_LABEL' | translate}}
        </button>

        <twc-loader *ngIf="isLoading" size="tiny" class="twc-ml-2 twc-mt-2"></twc-loader>

    </twc-popup-footer>

    <twc-popup-content *ngIf="!isPrincipalPopup">
        <p>{{'JOBS.CONFIRM_CANCEL_MSG' | translate : {jobName : cancelDialogName} }}</p>
    </twc-popup-content>

    <twc-popup-footer *ngIf="!isPrincipalPopup">
        <button class="twc-button twc-button-link" (click)="isPrincipalPopup=true">
            {{'GENERAL.NO' | translate}}
        </button>
        <button class="twc-button twc-button-primary twc-ml-3" (click)="closePopup()">
            {{'GENERAL.YES' | translate}}
        </button>
    </twc-popup-footer>

</twc-popup>